import React from 'react';
import type { ShareInlineProps } from '../ShareInline/ShareInline';
import { ShareInline } from '../ShareInline/ShareInline';
import type { Tag } from '../Tags/Tags';
import { Tags } from '../Tags/Tags';
import type { EventDescriptionProps } from './EventDescription/EventDescription';
import { EventDescription } from './EventDescription/EventDescription';
import type { DateAndTimeProps } from './EventDetails/DateAndTime/DateAndTime';
import { DateAndTime } from './EventDetails/DateAndTime/DateAndTime';
import type { LocationProps } from './EventDetails/Location/Location';
import { Location } from './EventDetails/Location/Location';
import type { PerformersProps } from './EventDetails/Performers/Performers';
import { Performers } from './EventDetails/Performers/Performers';
import type { RefundPolicyProps } from './EventDetails/RefundPolicy/RefundPolicy';
import { RefundPolicy } from './EventDetails/RefundPolicy/RefundPolicy';
import './EventInfo.scss';

export type EventInfoProps = {
    description: EventDescriptionProps;
    tags: Array<Tag>;
    shareInline: ShareInlineProps;
    eventDetails: {
        performers: PerformersProps;
        dates: DateAndTimeProps;
        location: LocationProps;
        refund: RefundPolicyProps;
    };
};

export const EventInfo = ({
    description,
    tags,
    shareInline,
    eventDetails: { performers, dates, location, refund },
}: EventInfoProps) => (
    <section className="event-info-wrapper">
        <div className="event-info">
            <div className="event-info__details">
                <Performers {...performers} />
                <DateAndTime {...dates} />
                <Location {...location} />
                <RefundPolicy {...refund} />
            </div>
            <div className="event-info__main">
                <EventDescription {...description} />
                <Tags tags={tags} />
                <ShareInline {...shareInline} />
            </div>
        </div>
    </section>
);
